import React, { Fragment } from 'react';
import OverlayWrapper from "../layout/OverlayWrapper";
export default function FloatingContainer({ children, onClose, mini = false, open, direction = 'right' }) { if (!open) {
    return null;
} const classes = `floating-container ${mini ? 'floating-container--mini' : ''} floating-container--${direction}`; return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(OverlayWrapper, { onClick: onClose }), /*#__PURE__*/ React.createElement("div", { className: classes }, children)); }
